const QUEUE_KEY = 'cliniqueSyncQueue';

const readQueue = () => {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY)) || [];
  } catch (error) {
    return [];
  }
};

export const queueSync = (operation) => {
  const queue = readQueue();
  queue.push({ ...operation, id: `${Date.now()}-${Math.random()}` });
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
};

export const getPendingSyncCount = () => readQueue().length;

export const flushSyncQueue = async (handlers) => {
  if (!navigator.onLine) return { synced: 0, pending: readQueue().length };

  const queue = readQueue();
  const remaining = [];
  let synced = 0;

  for (const operation of queue) {
    try {
      const handler = handlers[operation.type];
      if (typeof handler !== 'function') throw new Error(`Unknown sync operation: ${operation.type}`);
      await handler(operation.payload);
      synced += 1;
    } catch (error) {
      remaining.push(operation);
    }
  }

  localStorage.setItem(QUEUE_KEY, JSON.stringify(remaining));
  return { synced, pending: remaining.length };
};
